import { VisuallyHidden } from "@react-aria/visually-hidden";
import React, { ReactNode } from "react";

import "./styles.scss";

export type BadgeVariant = "default" | "info" | "success" | "danger" | "warning" | "primary" | "mustard" | "teal";

export type BadgeProps = {
  className?: string;
  variant?: BadgeVariant;
} & ({ circle?: false; children: ReactNode } | { circle: true; children: string });

export default function Badge(props: BadgeProps) {
  const classes = `
    c-badge
    c-badge--${props.variant ?? "default"}
    ${props.className ?? ""}
  `;

  if (props.circle) {
    return (
      <span className={`${classes} c-badge--circle`} title={props.children}>
        {props.children.substr(0, 1)}
        <VisuallyHidden>{props.children.substr(1)}</VisuallyHidden>
      </span>
    );
  }

  return <span className={classes}>{props.children}</span>;
}
